var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58143 19.9996H4.26429V9.3175H7.58143V19.9996ZM5.92107 7.86036C4.86036 7.86036 4 6.98179 4 5.92107C4 5.41157 4.2024 4.92294 4.56267 4.56267C4.92294 4.2024 5.41157 4 5.92107 4C6.43057 4 6.9192 4.2024 7.27947 4.56267C7.63974 4.92294 7.84214 5.41157 7.84214 5.92107C7.84214 6.98179 6.98143 7.86036 5.92107 7.86036ZM19.9964 19.9996H16.6864V14.7996C16.6864 13.5604 16.6614 11.9711 14.9618 11.9711C13.2371 11.9711 12.9729 13.3175 12.9729 14.7104V19.9996H9.65929V9.3175H12.8407V10.7746H12.8871C13.33 9.93536 14.4118 9.04964 16.0257 9.04964C19.3829 9.04964 20 11.2604 20 14.1318V19.9996H19.9964Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c3a5521dcb0b4b4694a3effacb1bcfcf.svg";
export { ForwardRef as ReactComponent };